// ---------------------------------------------------------------------------
// publicLinks — the client-facing URLs we hand out (2026-09-10, Jaylen:
// "/api/public-estimate?token=… looks sketchy to the uninitiated").
//
// Pretty paths are Vercel rewrites (vercel.json) onto the same serverless
// handlers, so the old /api/public-*?token= links keep working forever:
//   /estimate/<code>  → /api/public-estimate?token=<code>
//   /deposit/<code>   → /api/public-deposit?token=<code>
//   /terms/<code>     → /api/public-terms?token=<code>   (/terms alone is
//                        still the static terms.html)
//   /waiver/<code>    → /api/public-waiver?token=<code>  (?src= passes through)
//
// New codes are 12 chars of base62 (~71 bits — unguessable, half the
// length of the old 32-hex tokens). Existing tokens are untouched; the
// handlers only require length ≥ 8.
// ---------------------------------------------------------------------------

const ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

export function shortToken(length = 12) {
  const bytes = new Uint8Array(length);
  crypto.getRandomValues(bytes);
  // 256 % 62 ≠ 0 → tiny modulo bias; irrelevant for an unguessable-link
  // use case (we're not deriving keys from this).
  return Array.from(bytes, b => ALPHABET[b % ALPHABET.length]).join('');
}

const PATHS = { estimate: 'estimate', deposit: 'deposit', terms: 'terms', waiver: 'waiver' };

export function publicPath(kind, token, query = '') {
  const seg = PATHS[kind];
  if (!seg) throw new Error(`publicPath: unknown kind ${kind}`);
  return `/${seg}/${encodeURIComponent(token)}${query ? `?${query}` : ''}`;
}

// Origin for links we hand to clients. Set VITE_PUBLIC_ORIGIN in Vercel
// (e.g. https://docs.beatymoving.com — Jaylen 9/10: beatymoving.com
// itself is the vehicle-decal forwarder to beatybrothersmoving.com, so
// the apex stays a redirect and client links get one neutral subdomain) once
// that domain is attached to the project; until then links use whatever
// host the office is on, exactly as before.
export function publicOrigin() {
  const env = (import.meta.env?.VITE_PUBLIC_ORIGIN || '').trim().replace(/\/+$/, '');
  if (env) return env;
  return typeof window !== 'undefined' ? window.location.origin : '';
}

export function publicLink(kind, token, query = '') {
  return `${publicOrigin()}${publicPath(kind, token, query)}`;
}
